import React from 'react';
import PropTypes from 'prop-types';
import FluidTextBlocksContainer from '../FluidTextBlocksContainer/FluidTextBlocksContainer';
import FluidTextBlock from '../FluidTextBlock/FluidTextBlock';

const FluidTextBlocks3 = ({ config }) => {
  const { block1, block2, block3 } = config;

  return (
    <FluidTextBlocksContainer>
      <FluidTextBlock {...block1} />
      <FluidTextBlock {...block2} />
      <FluidTextBlock {...block3} />
    </FluidTextBlocksContainer>
  );
};

FluidTextBlocks3.propTypes = {
  config: PropTypes.shape({
    block1: PropTypes.node,
    block2: PropTypes.node,
    block3: PropTypes.node,
  }),
};

export default FluidTextBlocks3;
